module.exports = __webpack_public_path__ + "static/media/arup.13fbbc6a.png";